<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a" id="cont"><a id="page_6">contents</a></h2><a id="page_6">
</a><p class="tocfont"><a id="page_6"></a><a class="nounder" href="#/xhtml/intro#intro"><strong>introduction</strong></a></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch01#ch01" title="Link target outside of Sample"><strong>CHAPTER 01 vegetables</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample"><strong>CHAPTER 02 pasta and rice</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><strong>CHAPTER 03 beans</strong></span></p>
<p class="tocchap"><a id="page_7"></a><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample"><strong>CHAPTER 04 protein</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample"><strong>CHAPTER 05 sandwiches</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample"><strong>CHAPTER 06 fruit</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample"><strong>CHAPTER 07 snack attack</strong></span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/indes#index" title="Link target outside of Sample"><strong>index</strong></span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/table#table" title="Link target outside of Sample"><strong>table of equivalents</strong></span></p>
<p class="image"><a id="page_8"><img alt="Image" src="images/f0008-01.jpg"/></a></p><a id="page_8">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cont.vue?615e5839